/* tslint:disable */
/* eslint-disable */
/* @relayHash 5a71c1b353fb9e482f120fa5ccccd33a */

import { ConcreteRequest } from "relay-runtime";
export type DisconnectFirmInstagramMutationInput = {
    firmId: string;
    clientMutationId?: string | null;
};
export type disconnectInstagramMutationVariables = {
    input: DisconnectFirmInstagramMutationInput;
};
export type disconnectInstagramMutationResponse = {
    readonly disconnectFirmInstagramMutation: {
        readonly tradeFirm: {
            readonly instagram: {
                readonly username: string | null;
                readonly feed: ReadonlyArray<{
                    readonly imageUrl: string | null;
                    readonly link: string | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type disconnectInstagramMutation = {
    readonly response: disconnectInstagramMutationResponse;
    readonly variables: disconnectInstagramMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DisconnectFirmInstagramMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "disconnectInstagramMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "disconnectFirmInstagramMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DisconnectFirmInstagramMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "instagram",
                "storageKey": null,
                "args": null,
                "concreteType": "InstagramFeedType",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "feed",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InstagramFeedItemType",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "disconnectInstagramMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "disconnectFirmInstagramMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DisconnectFirmInstagramMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "instagram",
                "storageKey": null,
                "args": null,
                "concreteType": "InstagramFeedType",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "feed",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InstagramFeedItemType",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "disconnectInstagramMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/disconnectInstagramMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '7e6e157736c1b69b440a75470b1f67ca';
export default node;
